export enum FilterComparerGuids {
    Is = 'f05a9aa4-7c1c-4616-acd6-9cfa054e1687',
    IsNot = 'b3167812-87d3-414e-be46-79a515e2215c',
    IsBlank = 'b050f049-6558-4740-8b6c-ee8f85bb8ec6',
    Contains = '4b5f23c6-e5b8-4e5e-8aa4-7d2201ff8574',
    DoesNotContain = '7637d1d5-e760-4396-943a-b2bc6fbf1dc8',
    StartsWith = 'dd678fb2-d5a3-4369-807b-0719e013e33e',
    EndsWith = '1adf603c-f6e9-478a-8af2-1e0bc559a82d',
    Before = 'a8035fdf-047a-4963-8816-3e7fbd736332',
    After = 'b3d7ec70-0528-46bf-a405-1c29b5b59dbf',
    Between = 'd4f854d7-b344-4d76-9d5c-ed5cab7fedba',
    NotBetween = '2849b98b-ceb1-4db9-997c-ff7d20042356'
}
